import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "17",
  viewBox: "0 0 16 17",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M7.99967 3.5013C8.36786 3.5013 8.66634 3.20283 8.66634 2.83464C8.66634 2.46645 8.36786 2.16797 7.99967 2.16797C7.63148 2.16797 7.33301 2.46645 7.33301 2.83464C7.33301 3.20283 7.63148 3.5013 7.99967 3.5013Z",
      stroke: "#8E8E93",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M7.99967 9.16797C8.36786 9.16797 8.66634 8.86949 8.66634 8.5013C8.66634 8.13311 8.36786 7.83464 7.99967 7.83464C7.63148 7.83464 7.33301 8.13311 7.33301 8.5013C7.33301 8.86949 7.63148 9.16797 7.99967 9.16797Z",
      stroke: "#8E8E93",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M7.99967 15.0013C8.36786 15.0013 8.66634 14.7028 8.66634 14.3346C8.66634 13.9664 8.36786 13.668 7.99967 13.668C7.63148 13.668 7.33301 13.9664 7.33301 14.3346C7.33301 14.7028 7.63148 15.0013 7.99967 15.0013Z",
      stroke: "#8E8E93",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])))
}
export default { render: render }